import PrivateRoute from '@Auth/Components/PrivateRoute'

export const makePrivate = (View, props) => <PrivateRoute {...props}>{View}</PrivateRoute>
